import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { currentUser, isAdmin } = useAuth();

  // If user is not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If user is not an admin, redirect to home
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // User is logged in and is an admin, render the component
  return <>{children}</>;
};

export default AdminRoute;